<template>
  <div class="Payments">
    <h1 class="text-center my-7">میزان فروش</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-row>
          <v-col cols="12" md="6" class="pt-0 px-2">
            <v-card elevation="0" class="pa-3">
              <v-card-title class="justify-center">
                میزان فروش کتاب
                <v-chip small class="mr-2">قیمت به تومان است </v-chip>
              </v-card-title>
              <h2 class="text-center">
                <number :number="regularPayments.sum" unit="تومان"></number>
              </h2>
              <h4 class="text-center">
                <number :number="regularPayments.count" unit="خرید"></number>
              </h4>
              <v-alert
                dense
                outlined
                type="error"
                v-if="zeroPayments"
                class="text-center my-3"
              >
                تعداد
                <number :number="zeroPayments.count" unit="خرید"></number>
                صفر تومان
                <small>(با کد تخفیف - مدرسه ای)</small>
                نیز در سامانه ایجاد گردیده است.
              </v-alert>
              <v-btn
                depressed
                outlined
                block
                color="primary"
                router
                :to="{ name: 'UsersPayments' }"
              >
                مشاهده جزییات
              </v-btn>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="pt-0 px-2">
            <v-card elevation="0" class="pa-3">
              <v-card-title class="justify-center"
                >میزان فروش کد تخفیف
                <v-chip small class="mr-2">قیمت به تومان است </v-chip>
              </v-card-title>
              <h2 class="text-center">
                <number
                  :number="discountCodePayments.sum"
                  unit="تومان"
                ></number>
              </h2>
              <h4 class="text-center">
                <number
                  :number="discountCodePayments.count"
                  unit="خرید"
                ></number>
              </h4>
              <v-alert
                dense
                outlined
                type="error"
                v-if="zeroPayments"
                class="text-center my-3"
              >
                تعداد
                <number
                  :number="zeroDiscountCodePayments.count"
                  unit="خرید"
                ></number>
                صفر تومان
                <small>(مدرسه با درصد تخفیف 100)</small>
                نیز در سامانه ایجاد گردیده است.
              </v-alert>
              <v-btn
                depressed
                outlined
                block
                color="primary"
                router
                :to="{ name: 'SchoolsPayments' }"
              >
                مشاهده جزییات
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Navigation from "../_Navigation.vue";

export default {
  name: "payments-component",
  components: {
    Navigation
  },
  data() {
    return {
      regularPayments: {},
      zeroPayments: {},
      discountCodePayments: {},
      zeroDiscountCodePayments: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/countPayments").then((res) => {
        this.regularPayments = res.data.sumOfRegularPayments[0];
        this.zeroPayments = res.data.sumOfZeroPayments[0];
        this.discountCodePayments = res.data.sumOfDiscountCodePayments[0];
        this.zeroDiscountCodePayments =
          res.data.sumOfZeroDiscountCodePayments[0];
      });
    }
  }
};
</script>
